<template>
    <div>
        <v-menu
            :ref="name"
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
        >
            <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="result"
                    label="Pick time"
                    outline
                    single-line
                    :rules="rules.time"
                    v-bind="attrs"
                    v-on="on"
                ></v-text-field>
            </template>
            <v-time-picker
                v-if="menu"
                v-model="result"
                format="24hr"
            ></v-time-picker>
        </v-menu>
    </div>
</template>

<script>
export default {
    name: "Time",
    data () {
        return {
            menu: false,
            rules: {
                time: [
                    v => !!v || 'This field cannot be empty',
                    v => this.validateTime(v) || 'Invalid time format HH:mm'
                ]
            }
        }
    },
    props: {
        name: {
            type: String,
        },
        value: {
            type: String
        }
    },
    computed: {
        result: {
            get () {
                return this.value
            },
            set (val) {
                this.$emit('input', val)
            }
        }
    },
    methods: {
        validateTime (time) {
            let re = /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/
            return re.test(time)
        }
    }
}
</script>

<style scoped lang="scss">
.v-input.v-text-field .v-input__slot {
    min-height: 40px !important;
    border-radius: 0 !important;;
}
</style>
